// @see: app/views/shared/google/_analytics.html.erb
$(function () {
  'use strict';
  var env = process.env.RAILS_ENV;
  if (typeof ga !== 'undefined' && (env == 'production' || env == 'staging')) {
    $("a[data-track-category]").click(function() {
      // GoogleAnalytics イベントトラッキング ( staging , demo , production )
      ga('send', 'event', $(this).data('track-category'), $(this).data('track-action'));
    });
  }
});
